import React, { ReactElement } from 'react';

import Link from '../Link';
import { Pill as StyledPill, Inner } from './Pill.styled';

interface PillProps {
  children: React.ReactNode;
  as?: string;
  href?: string;
  onClick?: () => void;
  className?: string;
}

export function Pill({
  children,
  as,
  href,
  onClick,
  className,
  ...props
}: PillProps): ReactElement {
  return (
    <StyledPill className={className} {...props}>
      {href ? (
        <Link as={as} href={href} onClick={onClick}>
          <Inner>{children}</Inner>
        </Link>
      ) : (
        <Inner onClick={onClick}>{children}</Inner>
      )}
    </StyledPill>
  );
}
